module.exports = __webpack_public_path__ + "static/media/Martz90-Circle-Addon1-Text-plus.e0899db5.ico";